import { render, staticRenderFns } from "./Page04.vue?vue&type=template&id=28017463&scoped=true&"
import script from "./Page04.vue?vue&type=script&lang=js&"
export * from "./Page04.vue?vue&type=script&lang=js&"
import style0 from "./Page04.vue?vue&type=style&index=0&id=28017463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28017463",
  null
  
)

export default component.exports